import { RootState } from 'redux/store';

export type TimeFormatPreference = '12h' | '24h' | 'auto';

// The user's date/time-format preference, persisted in
// users.user_settings.timeFormat. Anything unrecognised (incl. absent) is
// treated as 'auto' — the pre-preference behaviour (follow the browser locale).
export const selectTimeFormat = (state: RootState): TimeFormatPreference => {
  const tf = state.auth.userData?.user_settings?.timeFormat;
  return tf === '12h' || tf === '24h' || tf === 'auto' ? tf : 'auto';
};

// Resolves the preference into an Intl `hour12` value. `undefined` means
// "do not force a cycle — let Intl resolve it from the browser locale".
export const selectHour12Option = (state: RootState): boolean | undefined => {
  const tf = selectTimeFormat(state);
  if (tf === '12h') return true;
  if (tf === '24h') return false;
  return undefined;
};

// Whether timestamps render in the browser's local timezone (true) or UTC /
// their source timezone (false). Persisted in user_settings.useLocalTimezone.
export const selectUseLocalTimezone = (state: RootState): boolean => state.auth.userData?.user_settings?.useLocalTimezone ?? false;
